import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpXhrBackend } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { BehaviorSubject } from 'rxjs';
import { RequestCacheService } from '../services/request-cache.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  baseUrl: string = environment.APIURL;

  httpClient = new HttpClient(new HttpXhrBackend({
    build: () => new XMLHttpRequest()
  }));
  aauSubdomain$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  usagSubdomain$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  jkfSubdomain$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  owtmaSubdomain$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  // `isSubdomain` from api/info/application
  isSubdomain$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // `leagueIds` from api/info/application ([] when not a subdomain); null until loaded
  subdomainLeagueIds$: BehaviorSubject<number[] | null> = new BehaviorSubject<number[] | null>(null);

  constructor(private http: HttpClient, private requestCacheService: RequestCacheService) { }

  public getInfo() {
    return this.requestCacheService.get(`${this.baseUrl}api/info/application`, undefined, 1000 * 60 * 60 * 24);
  }
}
